import { render } from "./VCard.vue?vue&type=template&id=6c8820d2"
import script from "./VCard.vue?vue&type=script&lang=js"
export * from "./VCard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__